import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import RhDropdownEditing from "./RhDropdownEditing";
import RhDropdownUI from "./RhDropdownUI";

export default class RhDropdown extends Plugin {
    static get requires() {
        return [ RhDropdownEditing, RhDropdownUI ];
    }
}
